// 项目OSS资源地址
export const OSS_RESOURCES_URL = 'https://fubei-scan-order-resources.oss-cn-hangzhou.aliyuncs.com'
export const shopDecorationImagesResourceBaseUrl = `${OSS_RESOURCES_URL}/order-h5-images/shopDecorationImages`

// 宫格导航菜单图标列表
export let menuNavigationIconMap = {}
for (let i = 0; i < 20; i++) {
  let idx = i + 1
  menuNavigationIconMap[`MENU_ICON_ITEM${idx}`] = `${shopDecorationImagesResourceBaseUrl}/menu_icon_item${idx}.png`
}

// 路径选择的数据映射关系
export let pathTypeMap = {
  normalGoods: {
    type: 'normalGoods',
    name: '普通商品'
  },
  limitedTimeActivity: {
    type: 'limitedTimeActivity',
    name: '特价商品'
  },
  goodsCategory: {
    type: 'goodsCategory',
    name: '商品分类'
  },
  orderPage: {
    type: 'orderPage',
    name: '点单页面'
  },
  deliveryType: {
    type: 'deliveryType',
    name: '配送方式'
  },
  limitedTimeActivityPage: {
    type: 'limitedTimeActivityPage',
    name: '特价页面'
  },
  myHomePage: {
    type: 'myHomePage',
    name: '我的页面'
  }
}

// 模版类型与显示的模版名称映射表
export let menuNavigationModuleTypeToNameMap = {
  fiveClassificationType: {
    type: 'fiveClassificationType',
    name: '分类入口(5个)',
    imageUrl: `${shopDecorationImagesResourceBaseUrl}/five_classification_type_img.png`
  },
  tenClassificationType: {
    type: 'tenClassificationType',
    name: '分类入口(10个)',
    imageUrl: `${shopDecorationImagesResourceBaseUrl}/ten_classification_type_img_2.png`
  },
  selfReceiveAndTakeawayType: {
    type: 'selfReceiveAndTakeawayType',
    name: '配送方式入口',
    imageUrl: `${shopDecorationImagesResourceBaseUrl}/self_receive_and_takeaway_type_img.png`
  }
}

// 模版类型与显示的模版名称映射表
export let eachTemplateToNameMap = {
  basicTemplate: {
    title: '基础模板',
    id: 'basicTemplate',
    img: `${shopDecorationImagesResourceBaseUrl}/template_basic_1.jpg?v=1.0.0`,
    previewImg: `${shopDecorationImagesResourceBaseUrl}/template_basic_preview_1.jpg?v=1.0.0`
  },
  freshTemplate: {
    title: '生鲜超市模板',
    id: 'freshTemplate',
    img: `${shopDecorationImagesResourceBaseUrl}/template_fresh_3.png?v=1.0.0`,
    previewImg: `${shopDecorationImagesResourceBaseUrl}/template_fresh_preview_3.jpg?v=1.0.0`
  },
  teaTemplate: {
    title: '茶饮食品模板',
    id: 'teaTemplate',
    img: `${shopDecorationImagesResourceBaseUrl}/template_tea_1.jpg?v=1.0.0`,
    previewImg: `${shopDecorationImagesResourceBaseUrl}/template_tea_preview_1.jpg?v=1.0.0`
  },
  foodTemplate: {
    title: '餐饮模板',
    id: 'foodTemplate',
    img: `${shopDecorationImagesResourceBaseUrl}/template_food_1.png?v=1.0.0`,
    previewImg: `${shopDecorationImagesResourceBaseUrl}/template_food_preview_1.jpg?v=1.0.0`
  }
} // 模版数据

// 图片显示类型
export const imageShowTypeMap = {
  slider: {
    name: '轮播',
    value: 'slider'
  },
  onePerLine: {
    name: '一行一个',
    value: 'onePerLine'
  }
}

// 门店筛选
export const storeFilterTypeMap = {
  DEFAULT_CHECKOUT_ICON: `${shopDecorationImagesResourceBaseUrl}/checkout_default_icon.png`, // 默认选中图标
  ACTIVE_CHECKOUT_ICON: `${shopDecorationImagesResourceBaseUrl}/checkout_active_icon.png`, // 选中图标
  DOWN_ICON: `${shopDecorationImagesResourceBaseUrl}/down_icon.png` // 向下箭头
}
